import { SafewordChoiceOptionsType } from '@/pages/Onboarding/options/SafewordChoice/types';

export const SAFEWORD_CHOICE_OPTIONS: SafewordChoiceOptionsType = [
  {
    id: 'little_control',
    title: 'Just a little control',
  },
  {
    id: 'no_control',
    title: 'No. Her rules, her will',
  },
  {
    id: 'safeword_whisper',
    title: "I'll whisper a safeword… but hope she doesn't listen",
  },
];
